"use client";

import { useMemo } from "react";
import { useWorkspaceSidePanelMode } from "./workspace-side-panel-mode";

/**
 * Compatibility facade for AI chat consumers. Physical panel state is owned by
 * WorkspaceSidePanelModeProvider as one discriminated union.
 */
export function useAiSidePanelVisibility() {
  const {
    isOpen,
    isVisible,
    openAiChat,
    closeWorkspaceSidePanel,
    toggleAiChat,
  } = useWorkspaceSidePanelMode();

  return useMemo(
    () => ({
      isOpen,
      isVisible,
      open: openAiChat,
      openWorkspaceSidePanel: openAiChat,
      closeWorkspaceSidePanel,
      close: closeWorkspaceSidePanel,
      toggle: toggleAiChat,
    }),
    [isOpen, isVisible, openAiChat, closeWorkspaceSidePanel, toggleAiChat],
  );
}
